import _ from "lodash";
import { getConfigurationEntityGroups } from "ChildrenPage/modules/ChildrenPageUtils";
import { CONFIGURATION_ENTITY_LIST } from "ChildrenPage/modules/ChildrenPageConstants";
import { getUserInfo } from "Login/modules/LoginModule/LoginUtils";
import { getAllConfigPermsMemoized } from "../components/Utils";
import { ROLE_VISITOR, STAFF } from "Constants/stringConstants";

export const getConfigurationQueryVariable = ({ contexts = [] }) => {
  const userInfo = getUserInfo();
  const userId = userInfo.id;
  const organizationId = userInfo.org_id;
  const userCurriculumProgramsId = _.map(userInfo.userCurriculumPrograms, "id");

  let identityId = userInfo.identityId;
  identityId = _.toString(identityId);

  let userType = userInfo.user_type;
  const isVisitor = _.isEqual(userInfo.role, ROLE_VISITOR);
  if (isVisitor) {
    userType = ROLE_VISITOR;
  }

  const groupInputList = [];
  groupInputList.push({
    userId,
    organizationId,
    identityId,
    entityTypes:
      !_.isEmpty(identityId) && _.isEqual(userType, STAFF)
        ? CONFIGURATION_ENTITY_LIST.ORGANIZATION_WITH_USER_AND_IDENTITY
        : CONFIGURATION_ENTITY_LIST.ORGANIZATION,
  });

  groupInputList.push(
    ..._.map(userCurriculumProgramsId, programId => ({
      currentCurriculumProgramId: programId,
      userId,
      entityTypes: CONFIGURATION_ENTITY_LIST.CURRICULUM,
    }))
  );

  // TODO: When we allow module visibility to toggle on course level by the users,
  // following entity group filters will needed to be added in the query
  // groupInputList.push(
  //   ..._.map(userAllCoursesId, courseId => ({
  //     courseId,
  //     userId,
  //     entityTypes: CONFIGURATION_ENTITY_LIST.COURSE,
  //   }))
  // );

  const configurationEntityGroupsList = _.map(groupInputList, group =>
    getConfigurationEntityGroups({
      userData: _.omit(group, "entityTypes"),
      entityTypes: _.get(group, "entityTypes"),
    })
  );

  const allConfigPerms = getAllConfigPermsMemoized({
    userType,
    contexts,
  });

  const configurationEntityGroupFilters = _.map(
    configurationEntityGroupsList,
    configurationEntityGroups => ({
      configurationEntityGroups,
      configurations: allConfigPerms,
    })
  );

  const variable = {
    configurationEntityGroupFilters,
    isAdminPage: false,
    isSettingsPage: false,
    portalType: "PLANNER",
  };

  return variable;
};

export const globalSearchConfigurationSelector = ({
  ownProps,
  getConfiguration,
}) => {
  const { isData, isLoading } = ownProps;

  const newConfigList = _.get(
    getConfiguration,
    "platform.configuration.0.configurations",
    []
  );

  const hasData = !_.isEmpty(newConfigList);

  return {
    isData: hasData && isData,
    isLoading: _.includes([1, 2], getConfiguration.networkStatus) || isLoading,
  };
};
